export default "__VITE_ASSET__BfnlvZ19__"